import React, {Component} from "react";
import {connect} from "react-redux";
import {AutoComplete, Button, Col, DatePicker, Divider, Empty, Icon, Input, Row, Select, Skeleton, Table} from "antd";
import {fetchLeasableAssetData, getAssetRevenueReportData, getLeasables} from '../../appRedux/actions';
import {CSVLink} from "react-csv";
import moment from "moment";

const {RangePicker} = DatePicker;


class RevenueReport extends Component {
  state = {
    reportData: [],
    periodFrom: '',
    periodTo: '',
    inputAsset: '',
    disableSearch: true,
    csv: null,
    finalReportData: [],
    downloadReportData: [],
    page: 1,
  };

  componentDidMount = () => {
    this.props.setPageTitle('Contract Revenue Report')
  }

  onClickSearch = () => {
    this.props.getAssetRevenueReportData({
      from: this.state.periodFrom,
      to: this.state.periodTo,
      asset: this.state.inputAsset,
    })
  }

  componentWillUnmount = () => {
    this.props.setPageTitle('');
  }

  onChangeDate = (date, dateString) => {
    if(dateString && dateString.length === 2) {
      this.setState({
        disableSearch: false,
        periodFrom: dateString[0],
        periodTo: dateString[1]
      })
    } else {
      this.setState({
        disableSearch: true,
        periodFrom: '',
        periodTo: ''
      })
    }
  }


  onSelect = (val) => {
    this.setState({
      inputAsset: val
    })
  }

  onChangeAsset = (val) => {
    if(!val) {
      this.setState({
        inputAsset: ''
      })
    }
  }

  assetSearch = (value, model = 'Asset', field = 'assetCode') => {
    if(value && value.length >= 2)
      this.props.fetchLeasableAssetData(value, model, field);
  };

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
      <div style={{padding: 8}}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{width: 188, marginBottom: 8, display: 'block'}}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{width: 90, marginRight: 8}}
        >
          Search
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{width: 90}}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{color: filtered ? '#1890ff' : undefined}}/>
    ),
    onFilter: (value, record) => {
      // console.log(value, record, dataIndex);
      if(dataIndex === 'client')
        return record['vendor']['name']
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase());
      else if(dataIndex === 'location')
        return record['location']['name']
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase());
      else if(dataIndex === 'leasingAsset')
        return record['leasingAsset']['assetCode']
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase());
      else if(dataIndex === 'assetType') {
        try {
          return record['subType']['assetType']['name']
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        } catch (e) {
          return false;
        }
      }
      else if(dataIndex === 'assetSubType')
        return record['subType']['name']
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase());
      else if(dataIndex === 'assetModel')
        return record['model']['name']
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase());
      else
        return record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase());
    },
    onFilterDropdownVisibleChange: visible => {
      if(visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      (text),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({searchText: ''});
  };

  getSuspendedDays = (record) => {
    const originalDays = record.days ? record.days.length : 0;
    const effectiveDays = record.physical_days ? record.physical_days.length : 0;
    return originalDays - effectiveDays;
  };

  getDates = (record, where) => {
    const dates = [...(record.physical_days || []), ...(record.suspense_days || [])].sort();
    if(where === 'from')
      return dates && dates.length ? dates[0] : '';
    return dates && dates.length ? dates[dates.length - 1] : '';
  };

  onClickDownload = (revenueData) => {
    // const {revenueData} = this.props;
    // const {finalReportData: revenueData} = this.state;
    this.setState({
      downloadReportData: revenueData.map(record => {
        return {
          Contract: record.contractCode || '',
          Vendor: record.vendor ? record.vendor.name : '',
          Location: record.location ? record.location.name : '',
          Asset: record.leasingAsset ? record.leasingAsset.assetCode : '',
          'Asset Type': (record.subType && record.subType.assetType && record.subType.assetType.name) ? record.subType.assetType.name : '',
          'Sub Type': (record.subType && record.subType.name) ? record.subType.name : '',
          'Asset Model': (record.model && record.model.name) ? record.model.name : '',
          'Date From': this.getDates(record, 'from'), // (record.days && record.days.length > 0) ? moment(record.days[0]).format('DD-MM-YYYY') : 0,
          'Date To': this.getDates(record, 'to'), // (record.days && record.days.length > 0) ? moment(record.days[record.days.length - 1]).format('DD-MM-YYYY') : '',
          Suspended: record.suspense_days ? record.suspense_days.length : 0,
          Days: record.physical_days ? record.physical_days.length : 0,
          Rate: record.rate ? parseFloat(record.rate).toFixed(2) : 0.00,
          Amount: record.amount ? Math.round(parseFloat(record.amount)).toFixed(2) : 0,
        };
      })
    })
  };

  componentWillReceiveProps(nextProps) {
    const {revenueData} = nextProps;
    if(revenueData && revenueData.length > 0) {
      this.setState({
        finalReportData: revenueData,
        page: 1
      })
    }
    // console.log(revenueData);
  }


  cols = (data) => {
    return [
      {
        title: "Sl.",
        dataIndex: "sl",
        key: "sl",
        width: 50,
        render: (_, __, index) => (this.state.page - 1) * 10 + (index + 1)
      },
      {
        title: "Contract",
        dataIndex: "contract",
        key: "contract",
        width: 50,
        // filters: [...new Set(data.map(item => item.contractCode))].map(doc => {
        //   return {
        //     text: doc,
        //     value: doc
        //   }
        // }),
        // onFilter: (value, record) => record.contractCode.indexOf(value) === 0,
        ...this.getColumnSearchProps('contractCode'),
        render: (_, record) => record.contractCode,
        sorter: (a, b) => (a.contractCode > b.contractCode) ? -1 : (a.contractCode < b.contractCode) ? 1 : 0,
      },
      {
        title: "Client",
        dataIndex: "client",
        key: "client",
        width: 100,
        ...this.getColumnSearchProps('client'),
        render: (_, record) => record.vendor ? record.vendor.name : '',
        sorter: (a, b) => (a.vendor.name || '' > b.vendor.name || '') ? -1 : (a.vendor.name || '' < b.vendor.name || '') ? 1 : 0,
        // filters: [...new Set(data.map(item => item.vendor.name || ''))].map(doc => {
        //   return {
        //     text: doc,
        //     value: doc
        //   }
        // }),
        // onFilter: (value, record) => (record.vendor.name || '').indexOf(value) === 0,
      },
      {
        title: "Location",
        dataIndex: "location",
        key: "location",
        width: 150,
        ...this.getColumnSearchProps('location'),
        render: (_, record) => record.location ? record.location.name : '',
        sorter: (a, b) => (a.location.name || '' > b.location.name || '') ? -1 : (a.location.name || '' < b.location.name || '') ? 1 : 0,
        // filters: [...new Set(data.map(item => item.location.name || ''))].map(doc => {
        //   return {
        //     text: doc,
        //     value: doc
        //   }
        // }),
        // onFilter: (value, record) => (record.location.name || '').indexOf(value) === 0,
      },
      {
        title: "Asset Code",
        dataIndex: "code",
        key: "code",
        width: 100,
        ...this.getColumnSearchProps('leasingAsset'),
        render: (_, record) => (record.leasingAsset && record.leasingAsset.assetCode) ? record.leasingAsset.assetCode : '',
        sorter: (a, b) => ((a.leasingAsset && a.leasingAsset.assetCode) ? a.leasingAsset.assetCode : '' > (b.leasingAsset && b.leasingAsset.assetCode) ? b.leasingAsset.assetCode : '') ? -1
          : (a.leasingAsset && a.leasingAsset.assetCode) ? a.leasingAsset.assetCode : '' < (b.leasingAsset && b.leasingAsset.assetCode) ? b.leasingAsset.assetCode : '' ? 1 : 0,
        // filters: [...new Set(data.map(item => (item.leasingAsset && item.leasingAsset.assetCode) ? item.leasingAsset.assetCode : ''))].map(doc => {
        //   return {
        //     text: doc,
        //     value: doc
        //   }
        // }),
        // onFilter: (value, record) => ((record.leasingAsset && record.leasingAsset.assetCode) ? record.leasingAsset.assetCode : '').indexOf(value) === 0,
      },
      {
        title: "Asset Type",
        dataIndex: "assetType",
        key: "assetType",
        width: 150,
        ...this.getColumnSearchProps('assetType'),
        render: (_, record) => (record.subType && record.subType.assetType && record.subType.assetType.name) ? record.subType.assetType.name : '',
        sorter: (a, b) => ((a.subType && a.subType.assetType && a.subType.assetType.name) ? a.subType.assetType.name : '' > (b.subType && b.subType.assetType && b.subType.assetType.name) ? b.subType.assetType.name : '')
          ? -1 : ((a.subType && a.subType.assetType && a.subType.assetType.name) ? a.subType.assetType.name : '' < (b.subType && b.subType.assetType && b.subType.assetType.name) ? b.subType.assetType.name : '') ? 1 : 0,
        // filters: [...new Set(data.map(item => (item.subType && item.subType.assetType && item.subType.assetType.name) ? item.subType.assetType.name : ''))].map(doc => {
        //   return {
        //     text: doc,
        //     value: doc
        //   }
        // }),
        // onFilter: (value, record) => ((record.subType && record.subType.assetType && record.subType.assetType.name) ? record.subType.assetType.name : '').indexOf(value) === 0,
        // sorter: (a, b) => (a.leasingAsset.assetCode || '' > b.leasingAsset.assetCode || '') ? -1 : (a.leasingAsset.assetCode || '' < b.leasingAsset.assetCode || '') ? 1 : 0,
        // filters: [...new Set(data.map(item => item.leasingAsset.assetCode || ''))].map(doc => {
        //   return {
        //     text: doc,
        //     value: doc
        //   }
        // }),
        // onFilter: (value, record) => (record.location.name || '').indexOf(value) === 0,
      },
      {
        title: "Asset Sub Type",
        dataIndex: "assetSubType",
        key: "assetSubType",
        width: 150,
        ...this.getColumnSearchProps('assetSubType'),
        render: (_, record) => (record.subType && record.subType.name) ? record.subType.name : '',
        sorter: (a, b) => ((a.subType && a.subType.name) ? a.subType.name : '' > (b.subType && b.subType.name) ? b.subType.name : '')
          ? -1 : ((a.subType && a.subType.name) ? a.subType.name : '' < (b.subType && b.subType.name) ? b.subType.name : '') ? 1 : 0,
        // filters: [...new Set(data.map(item => (item.subType && item.subType.name) ? item.subType.name : ''))].map(doc => {
        //   return {
        //     text: doc,
        //     value: doc
        //   }
        // }),
        // onFilter: (value, record) => ((record.subType && record.subType.name) ? record.subType.name : '').indexOf(value) === 0,
      },
      {
        title: "Asset Model",
        dataIndex: "assetModel",
        key: "assetModel",
        width: 150,
        ...this.getColumnSearchProps('assetModel'),
        render: (_, record) => (record.model && record.model.name) ? record.model.name : '',
        sorter: (a, b) => ((a.model && a.model.name) ? a.model.name : '' > (b.model && b.model.name) ? b.model.name : '')
          ? -1 : ((a.model && a.model.name) ? a.model.name : '' < (b.model && b.model.name) ? b.model.name : '') ? 1 : 0,
        // filters: [...new Set(data.map(item => (item.model && item.model.name) ? item.model.name : ''))].map(doc => {
        //   return {
        //     text: doc,
        //     value: doc
        //   }
        // }),
        // onFilter: (value, record) => ((record.model && record.model.name) ? record.model.name : '').indexOf(value) === 0,
      },
      {
        title: "Lease From",
        dataIndex: "leaseFrom",
        key: "leaseFrom",
        // render: (_, record) => (record.days && record.days.length > 0) ? record.days[0] : '',
        render: (_, record) => {
          const dates = [...(record.physical_days || []), ...(record.suspense_days || [])].sort();
          // console.log('Dates - ', dates, record.physical_days, record.suspense_days);
          return dates && dates.length ? moment(dates[0]).format('YYYY-MM-DD') : '';
        },
        // sorter: (a, b) => (a.physical_days.length && a.physical_days[0] > b.physical_days.length && b.physical_days[0]) ? -1 : (a.physical_days.length && a.physical_days[0] < b.physical_days.length && b.physical_days[0]) ? 1 : 0,
        width: 150,
      },
      {
        title: "Lease To",
        dataIndex: "leaseTo",
        key: "leaseTo",
        // render: (_, record) => (record.days && record.days.length > 0) ? record.days[record.days.length - 1] : '',
        render: (_, record) => {
          const dates = [...(record.physical_days || []), ...(record.suspense_days || [])].sort();
          // console.log('Dates - ', dates, record.physical_days, record.suspense_days);
          return dates && dates.length ? moment(dates[dates.length - 1]).format('YYYY-MM-DD') : '';
        },
        // sorter: (a, b) => (a.physical_days.length && a.physical_days[a.physical_days.length - 1] > b.physical_days.length && b.physical_days[b.physical_days.length - 1])
        //   ? -1 : (a.physical_days.length && a.physical_days[a.physical_days.length - 1] < b.physical_days.length && b.physical_days[b.physical_days.length - 1]) ? 1 : 0,
        width: 150,
      },
      {
        title: "Suspended",
        dataIndex: "suspended",
        key: "suspended",
        render: (_, record) => record.suspense_days ? record.suspense_days.length : 0,
        width: 50,
        fixed: 'right',
        align: 'right',
        // sorter: (a, b) => (a.physical_days.length || 0 > b.physical_days.length || 0)
        //   ? -1 : (a.physical_days.length || 0 < b.physical_days.length  || 0) ? 1 : 0,

      },
      {
        title: "Days",
        dataIndex: "days",
        key: "days",
        render: (_, record) => record.physical_days ? record.physical_days.length : 0,
        width: 50,
        fixed: 'right',
        align: 'right',
        // sorter: (a, b) => (a.physical_days.length || 0 > b.physical_days.length || 0)
        //   ? -1 : (a.physical_days.length || 0 < b.physical_days.length  || 0) ? 1 : 0,

      },
      {
        title: "Rate",
        dataIndex: "rate",
        key: "rate",
        render: (_, record) => record.rate ? parseFloat(record.rate).toFixed(2) : 0.00,
        width: 100,
        fixed: 'right',
        align: 'right',
      },
      {
        title: "Amount",
        dataIndex: "amount",
        key: "amount",
        render: (_, record) => record.amount ? Math.round(parseFloat(record.amount)).toFixed(2) : 0.00,
        width: 150,
        fixed: 'right',
        align: 'right',
      },
    ];

    // console.log(cc);
  };

  changePage = (current) => this.setState({page: current});

  render() {
    const {finalReportData: revenueData} = this.state;
    const assetInput = (
      <AutoComplete allowClear onChange={this.onChangeAsset} onSelect={this.onSelect} onSearch={this.assetSearch}
                    placeholder={'Asset Code'}>
        {
          (this.props.assetData || []).map(item => (
            <Select.Option key={item._id} value={item._id}>{item.assetCode}</Select.Option>))
        }
      </AutoComplete>);
    const inputs = (
      <div>
        <Row>
          <Col span={12}><RangePicker autoFocus placeholder={['Period From', 'Period To']} style={{width: '100%'}}
                                      onChange={this.onChangeDate}
            // disabledDate={(current) => current && current >= moment().endOf('day')}
          /></Col>
          <Col span={6}>{assetInput}</Col>
          <Col span={3}><Button disabled={this.state.disableSearch} type="primary" icon="search"
                                onClick={this.onClickSearch}>Search</Button></Col>
          {/*<Col span={3}><Button disabled={(!(revenueData && revenueData.length > 0))} icon="download"*/}
          {/*onClick={() => this.onClickDownload(revenueData)}>CSV</Button></Col>*/}
          <Col span={3}>
            <CSVLink
              data={this.state.downloadReportData}
              onClick={() => this.onClickDownload(revenueData)}
              asyncOnClick={true}
              filename={"contract-revenue-report-" + Date.now() + ".csv"}
              target="_blank">
              <Button disabled={(!(revenueData && revenueData.length > 0))} icon="download">CSV</Button>
            </CSVLink></Col>
        </Row>
      </div>
    );

    let revenues = <Skeleton active/>;

    if(this.props.loading === false) {
      if(revenueData && revenueData.length > 0) {
        let that = this;
        revenues = <Table
          //onChange={this.handleTableChange}
          dataSource={revenueData}
          // pagination={false}
          pagination={{
            onChange(current) {
              that.changePage(current)
            }
          }}
          columns={this.cols(revenueData)}
          loading={this.props.loading}
          scroll={{x: true}}

          // scroll={{ y: 250 }}
          // rowKey={(record) =>
          //   record.type +
          //   record.location._id +
          //   (record.client && record.client._id)
          // }
        />
      } else revenues = <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
      ;
    }


    return (
      <div>
        {inputs}
        <Divider/>
        {revenues}
        {this.state.csv}
      </div>
    );
  }
}

const
  mapStateToProps = ({auth, leasing, contract, commonData}) => {
    return {
      authUser: auth.authUser,
      revenueData: leasing.revenueReportData,
      loading: commonData.loading,
      data: contract.resources,
      resource: contract.resource,
      assetData: commonData.relationshipSearch,
    };
  };

function

mapDispatchToProps(dispatch) {
  return {
    getLeasables,
    getAssetRevenueReportData,
    fetchLeasableAssetData
  };
}

export default connect(mapStateToProps, mapDispatchToProps

())(
  RevenueReport
)
;
